import React from 'react'
import { BsArrowRight } from 'react-icons/bs'

const ProjectSection = () => {
  return (
    <div>
        <section className=" py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-slate-900 text-center mb-12">Related Blogs</h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-slate-50 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div className="h-48 bg-gradient-to-br from-slate-200 to-slate-300"></div>
            <div className="p-6">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">IT staff augmentation</h3>
              <button className="text-cyan-600 hover:text-cyan-700 font-medium flex items-center space-x-2">
                <span>Read more</span>
                <BsArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="bg-slate-50 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <div className="h-48 bg-gradient-to-br from-blue-200 to-cyan-300"></div>
            <div className="p-6">
              <h3 className="text-xl font-semibold text-slate-900 mb-4">
                Harnessing the Benefits of Cloud-based Fintech Software for Scalability and Flexibility
              </h3>
              <button className="text-cyan-600 hover:text-cyan-700 font-medium flex items-center space-x-2">
                <span>Read more</span>
                <BsArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default ProjectSection